<template>
  <div class="searchbox-wrapper">
    <input
      type="text"
      class="form-control"
      v-model.trim="query"
      :placeholder="placeholder"
      :style="{ width, height }"
      @keyup.enter="handleSearch"
    />
    <div class="icon-wrapper clear" v-show="query" @click="clearQuery">
      <fa icon="times-circle"></fa>
    </div>
    <div
      class="icon-wrapper history"
      v-show="!query"
      @click="toggleHistoryList"
    >
      <fa icon="history"></fa>
    </div>
    <div class="icon-wrapper search" @click="handleSearch">
      <fa icon="arrow-alt-circle-right" class="icon"></fa>
    </div>
    <div
      v-if="canShowHistoryList"
      class="history-list"
      v-click-outside="toggleHistoryList"
    >
      <h6>Recent member accounts:</h6>
      <div v-if="historyList.length === 0" class="no-data">
        <span>No data</span>
      </div>
      <template v-if="historyList.length > 0">
        <ul>
          <li
            v-for="(item, index) in historyList"
            :key="index"
            @click="selectHistory(item)"
          >
            {{ item }}
          </li>
        </ul>
        <div
          v-if="historyList.length > 0"
          class="clear-history"
          @click="clearHistory"
        >
          <span>Clear all</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import * as vClickOutside from 'v-click-outside';
import { LOCAL_STORAGE_ITEM_LIST } from '../../constants/common';
import { MAX_QUERY_HISTORY_ENTRIES_APNIC_STAFF } from '../../constants/common';

export default {
  name: 'SearchBoxForAPNICStaff',
  directives: { clickOutside: vClickOutside.directive },
  props: {
    placeholder: {
      type: String,
      default: 'Go to member account'
    },
    width: {
      type: String,
      default: '17rem'
    },
    height: {
      type: String,
      default: '2rem'
    }
  },
  data() {
    return {
      historyList: [],
      canShowHistoryList: false,
      maxHistoryEntries: MAX_QUERY_HISTORY_ENTRIES_APNIC_STAFF
    };
  },
  computed: {
    ...mapState('dataStore', ['memberAccountQueryOfAPNICStaff']),

    query: {
      get() {
        return this.memberAccountQueryOfAPNICStaff;
      },
      set(val) {
        this.setMemberAccountQueryOfAPNICStaff(val);
      }
    }
  },
  methods: {
    ...mapMutations('dataStore', ['setMemberAccountQueryOfAPNICStaff']),
    handleSearch() {
      this.$emit('onSearch', this.query);
    },
    clearQuery() {
      this.query = '';
    },
    toggleHistoryList() {
      this.canShowHistoryList = !this.canShowHistoryList;

      if (this.canShowHistoryList) {
        const history =
          localStorage.getItem(
            LOCAL_STORAGE_ITEM_LIST.MEMBER_ACCOUNT_QUERY_HISTORY
          ) || '[]';

        this.historyList = JSON.parse(history);
      }
    },
    clearHistory() {
      localStorage.removeItem(
        LOCAL_STORAGE_ITEM_LIST.MEMBER_ACCOUNT_QUERY_HISTORY
      );
      this.canShowHistoryList = false;
    },
    selectHistory(memberAccountName) {
      this.canShowHistoryList = false;
      this.query = memberAccountName;
      this.handleSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
.searchbox-wrapper {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;

  input {
    text-transform: uppercase;
  }

  input::placeholder {
    text-transform: initial;
  }

  .icon-wrapper {
    position: absolute;
    width: 2rem;
    text-align: center;
    cursor: pointer;
    color: $text-grey;

    &:hover {
      color: $icon-grey;
    }
  }

  .search {
    right: 0;
  }

  .history,
  .clear {
    right: 2rem;
  }

  .history-list {
    position: absolute;
    z-index: 99;
    top: 2rem;
    left: 0;
    right: 0;
    background-color: white;
    border: 2px solid white;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.4);
    padding: 0.5rem 0;

    h6 {
      margin: 0.5rem 1rem;
    }

    .no-data {
      text-align: center;

      span {
        font-style: italic;
      }
    }

    ul {
      list-style: none;
      margin: 0;

      li {
        display: block;
        padding: 0.5rem 1rem;

        cursor: pointer;

        &:hover {
          background-color: #ccc;
        }
      }
    }

    .clear-history {
      text-align: center;
      margin: 0.25rem 0.5rem;

      span {
        color: $apnic-blue;
        cursor: pointer;
      }
    }
  }
}
</style>
